/**
 *
 * LegalDocuments
 *
 */
import * as React from 'react';
import { Route, Routes } from 'react-router-dom';
import { Edit } from './Edit';

interface Props {}

export function LegalDocuments(props: Props) {
  return (
    <Routes>
      <Route path={``} element={<Edit />} />
    </Routes>
  );
}
